<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          Users
          <div class="float-right">
            <div class="col">
              <select id="override" @change="onChange($event)"  class="form-control form-control-sm">
                  <option value="1">Activate</option>
                  <option value="0">Deactivate</option>
                  <option value="2">Block</option>
              </select>
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <loading :active.sync="isLoading"
          :can-cancel="false"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
          <v-client-table v-bind:data="resources" v-bind:columns="columns" :options="options" id="dataTable" class="resource-list">
            <span slot="name" slot-scope="props" class="display-link"> {{props.row._id}} </span>
            <span slot="fullname" slot-scope="props">{{props.row.firstname}} {{props.row.lastname}}</span>
            <span slot="phone" slot-scope="props">{{props.row.countrycode}} {{props.row.phone}}
              <span v-if="props.row.isverified" class="verified">
                <font-awesome-icon :icon="['fas', 'check']" />
              </span>
            </span>
            <span v-if="props.row.email" slot="email" slot-scope="props">{{props.row.email}}</span><span slot="email" slot-scope="props" v-else>N/A</span>
            <!-- <span slot="profilepicture" slot-scope="props">{{props.row.pic}}</span> -->
            <img slot="profilepicture" style="width: 100px; height: 100px;" slot-scope="props" :src="API_URL+'users/' + props.row.pic" @error="$event.target.src = APP_URL+'no_image.png'" />
            <span slot="createddate" slot-scope="props">{{ props.row.createdAt | momentDate }} </span>
            <span slot="action" slot-scope="props">
              <div class="row">
                <div class="col">
                  <select id="override" v-model="props.row.active" v-on:change="ChangeServiceStatus(props.row._id)"  class="form-control form-control-sm">
                      <option value="0">Deactivate</option>
                      <option value="1">Activate</option>
                      <option value="b0" v-if="props.row.blockByAdmin==1">Unblock</option>
                  </select>
                </div>
                <div class="col">
                  <button slot="name" class="display-link" @click="redirectUrls('/users-details/'+props.row._id)" data-toggle="tooltip" data-placement="top" title="View">
                    <font-awesome-icon :icon="['far', 'eye']" />
                  </button>
                </div>
              </div>
            </span>
            <!-- <span slot="view" slot-scope="props">
              <button slot="name" class="display-link" @click="redirectUrls('/users-details/'+props.row._id)">View</button>
            </span> -->
          </v-client-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: 'userList',
    data() {
        return {
            showAddBtn: true,
            isLoading: false,
            fullPage: true,
            resources: [],
            columns: ['fullname', 'profilepicture', 'email', 'phone', 'createddate', 'action'],
            activeOptions: [{id: 0, text: 'Deactive'}, {id: 1, text: 'Active'}],
            selectedOption: 1,
            token: localStorage.getItem('token'),
            API_URL: API_URL,
            APP_URL: APP_URL,
            tokenChange: JSON.parse(localStorage.getItem('token')),
            options: {
              headings: {
                createddate: 'Created Date',
                fullname: 'Full Name',
                profilepicture: 'Profile Picture'
              },
              sortable: ['fullname', 'email', 'createddate'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              },
              texts:{
                filterPlaceholder:"Search",
                filter:"Search",
                count: "Showing {from} to {to} of {count} records"
                // count: "Showing {from} to {to} of {count} records|{count} records|One record"
              },
            }
        }
    },
    components: {
        Loading
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    created() {
        this.loadData();
        document.title = "User list";
    },
    methods: {
        loadData() {
            this.isLoading = true;
            this.showLoader();
            axios.get(`${API_ADMIN_URL}/usersList`, {headers: {'x-access-token': this.tokenChange}}).then(response => {

                if (response.data.status == 200) {
                    this.resources = response.data.data;
                    this.isLoading = false;
                    this.selectedOption = 1;
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
              this.hideLoader();
            });
        },
        moment: function (date) {
          return moment(date);
        },
        ChangeServiceStatus: function(userId) {
            axios.post(`${API_ADMIN_URL}/changeActiveStatus/`, {userId: userId, status: event.target.value, value: this.selectedOption}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                this.isLoading = true;
                if (response.data.status == 200) {
                    // this.loadData();
                    this.resources = response.data.data;
                    this.showSuccessMsg({message: response.data.message});
                    this.isLoading = false;
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        },
        onChange:function(event){
          // console.log(event.target.value);
          axios.post(`${API_ADMIN_URL}/getByStatusUsersList/`, {status: event.target.value}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                this.isLoading = true;
                if (response.data.status == 200) {
                    this.resources = response.data.data;
                    this.selectedOption = event.target.value;
                    this.isLoading = false;
                    this.isLoading = false;
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        },
        onCancel() {
          // console.log('User cancelled the loader.')
        },
        showLoader: function() {
            this.$isLoading = true;
            this.$emit('loading', true);
        },
        hideLoader: function() {
            this.$isLoading = false;
            this.$emit('loading', false);
        },
        redirectUrls: function(link) {
            this.$router.push(link);
        }
    }
}
</script>
